export default __webpack_public_path__ + "static/rs-51e6180ced2cf59fd51e42fcc904988b.svg";